export default {
  path: 'plc',
  name: 'plc',
  component: () => import('@/pages/plc/PlcIndex'),
  meta: { title: 'KOL刊例', alive: true },
  children: [
    {
      path: 'add',
      name: 'plc_create',
      component: () => import('@/pages/plc/CreateEdit'),
      meta: { title: '新建月刊' }
    },
    {
      path: ':id/edit',
      name: 'plc_edit',
      component: () => import('@/pages/plc/CreateEdit'),
      meta: { title: '修改月刊' }
    },
    {
      path: ':year/:month/list',
      name: 'plc_list',
      component: () => import('@/pages/publication/PlcList'),
      meta: { title: '月刊列表' }
    },
    {
      path: 'item/:id',
      name: 'plc_detail_item',
      component: () => import('@/pages/plc/journal/submission.vue'),
      meta: { title: '刊例详情' }
    },
    {
      path: 'plc_item_detail/:id',
      name: 'plc_item_detail',
      component: () => import('@/pages/plc/journal/submission.vue'),
      meta: { title: '刊例详情' }
    },
    {
      path: 'plc_check/:id/item',
      name: 'plc_item',//刊例-审核页面
      component: () => import('@/pages/plc/check/PlcItemDetail'),
      meta: { title: 'KOL刊例提报详情', alive: true }
    },
    {
      path: ':id/tpl',
      component: () => import( '@/pages/plc/setting/PlcTpl.vue'),
      name: 'plc_tpl',
      meta: { title: '刊例配置' }
    },
    {
      path: 'price/list',
      component: () => import( '@/pages/plc/price/list.vue'),
      name: 'plc_tpl_price_list',
      meta: { title: '月刊报价列表' }
    },

  ]
}
